import { render, staticRenderFns } from "./SSelectorChips.vue?vue&type=template&id=6e8c32a7&scoped=true"
import script from "./SSelectorChips.vue?vue&type=script&lang=ts"
export * from "./SSelectorChips.vue?vue&type=script&lang=ts"
import style0 from "./SSelectorChips.vue?vue&type=style&index=0&id=6e8c32a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8c32a7",
  null
  
)

export default component.exports